import React from 'react';

import { Card, Skeleton } from '@mint-lib/tw-components';

const SkeletonSuggestionCard = () => {
  return (
    <Card
      data-testid="skeleton-suggestion-card"
      variant="outlined"
      contentClassName="flex flex-col p-0 gap-3"
      className="flex w-full flex-col overflow-visible p-3"
    >
      <div className="flex h-5.5 flex-row items-start justify-between">
        <Skeleton variant="rounded" className="h-5.5 w-56.5" />
        <Skeleton variant="rounded" className="h-5.5 w-21" />
      </div>
      <div className="flex flex-row justify-between">
        <Skeleton variant="rounded" className="h-5 w-21" />
        <Skeleton variant="rounded" className="h-5 w-21" />
      </div>
    </Card>
  );
};

export default SkeletonSuggestionCard;
